import React from 'react';
import s from './index.module.css';
import { useSelector } from 'react-redux';

import { getOrders } from '../../store/selectors';

import Order from './Order/Order';
import { ReactComponent as CarIcon } from './CarIcon.svg';

import { validStatuses } from './Order/OrderStatus/statuses';

const OrdersList = () => {
    const orders = useSelector(getOrders);
    const isOrdersListVisible = orders.length > 0;

    return (
        <ul className={s.ordersList}>
            {isOrdersListVisible ?
                orders.map((order) => {
                    return (
                        validStatuses.includes(order.status) &&
                        <li className={s.ordersListItem} key={order.deliveryOrderId}>
                            {
                                <Order
                                    deliveryOrderId={order.deliveryOrderId}
                                    deliveryPlanDate={order.deliveryPlanDate}
                                    createdDate={order.createdDate}
                                    storeSchedule={order.storeSchedule}
                                    status={order.status}
                                    cancelDate={order.cancelDate}
                                    existsCanceledOrders={order.existsCanceledOrders}
                                    deliveryChangedPlanDate={order.deliveryChangedPlanDate}
                                    deliveryDays={order.deliveryDays}
                                    storageEndDate={order.storageEndDate} />}
                        </li>
                    )
                })
                :
                <div className={s.noOrdersDisclamer}>
                    <h3>Статус заказов</h3>
                    <div className={s.disclamerBody}>
                        <div><CarIcon /></div>
                        <p>Все активные заказы будут отображаться здесь</p>
                    </div>
                </div>
            }
        </ul>
    );
};

export default OrdersList;
